// Typography styles based on _base.scss
import type { BaseStyles } from '../../themes/ThemeTypes';

import colors from './colors';
import fonts from './fonts';

export const baseStyles: BaseStyles = {
  typography: {
    body: {
      fontFamily: 'Poppins',
      fontWeight: fonts.fontWeights.normal,
      fontSize: '16px',
      lineHeight: '26px',
    },
    p: {
      lineHeight: 'inherit',
      '${max.sm}': {
        fontSize: '14px',
        lineHeight: '20px',
      },
      b: {
        fontWeight: fonts.fontWeights.bold,
      },
    },
    h1: {
      color: colors.dark,
      fontWeight: fonts.fontWeights.bold,
      fontSize: '26px',
      lineHeight: '32px',
      '${max.sm}': {
        textAlign: 'center',
      },
      '${min.sm}': {
        fontSize: '32px',
        lineHeight: '38px',
      },
      '${min.md}': {
        fontSize: '40px',
        lineHeight: '46px',
      },
    },
    h2: {
      fontWeight: 700,
      color: colors.primary,
      fontSize: '22px',
      lineHeight: '28px',
      '${min.sm}': {
        fontSize: '26px',
        lineHeight: '32px',
      },
      '${min.md}': {
        fontSize: '30px',
        lineHeight: '36px',
      },
    },
    h3: {
      fontWeight: 800,
      color: colors.dark,
      fontSize: '18px',
      lineHeight: '24px',
      '${min.sm}': {
        fontSize: '20px',
        lineHeight: '26px',
      },
      '${min.md}': {
        fontSize: '22px',
        lineHeight: '28px',
      },
    },
    h4: {
      fontWeight: fonts.fontWeights.medium,
      color: colors.dark,
      fontSize: '18px',
      lineHeight: '24px',
    },
    h5: {
      fontSize: '16px',
      fontWeight: 800,
      color: colors.dark,
      lineHeight: '22px',
    },
    a: {
      color: colors.primary,
      textDecoration: 'underline',
      cursor: 'pointer',
      lineHeight: '20px',
      '&:hover': {
        color: colors.primaryHover,
      },
    },
  },
};

export default baseStyles;
